import createIcon from '../../createIcon';

/**
 * @component @name Nightlight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyQzE2LjMyIDIgMTguMDMgMi41IDE5LjUgMy4zNUMxNi41MSA1LjA4IDE0LjUgOC4zIDE0LjUgMTJDMTQuNSAxNS43IDE2LjUxIDE4LjkyIDE5LjUgMjAuNjVDMTguMDMgMjEuNSAxNi4zMiAyMiAxNC41IDIyQzguOTggMjIgNC41IDE3LjUyIDQuNSAxMkM0LjUgNi40OCA4Ljk4IDIgMTQuNSAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Nightlight = createIcon('Nightlight', [
  [
    'path',
    {
      d: 'M14.5 2C16.32 2 18.03 2.5 19.5 3.35C16.51 5.08 14.5 8.3 14.5 12C14.5 15.7 16.51 18.92 19.5 20.65C18.03 21.5 16.32 22 14.5 22C8.98 22 4.5 17.52 4.5 12C4.5 6.48 8.98 2 14.5 2Z',
      key: '95hodh',
    },
  ],
]);

export default Nightlight;
